const IconRocket = ({ className }) => {
    return (
        <svg
            width='33'
            height='32'
            viewBox='0 0 33 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Vector'
                d='M6.00968 22.5455C3.82786 24.3782 3.10059 29.8182 3.10059 29.8182C3.10059 29.8182 8.54059 29.091 10.3733 26.9092C11.406 25.6873 11.3915 23.811 10.2424 22.6764C9.67703 22.1368 8.93229 21.825 8.1511 21.8008C7.36991 21.7767 6.60732 22.0419 6.00968 22.5455Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                id='Vector_2'
                d='M16.9188 20.3636L12.5552 15.9999C13.3292 13.9918 14.3038 12.0669 15.4643 10.2545C17.1591 7.54462 19.519 5.31344 22.3195 3.77314C25.1201 2.23284 28.2681 1.43464 31.4643 1.45446C31.4643 5.41083 30.3297 12.3636 22.737 17.4545C20.8997 18.6162 18.9506 19.5908 16.9188 20.3636Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                id='Vector_3'
                d='M12.5554 16H5.28271C5.28271 16 6.08271 11.5927 8.19181 10.1818C10.5482 8.61092 15.4645 10.1818 15.4645 10.1818'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                id='Vector_4'
                d='M16.9189 20.3637V27.6364C16.9189 27.6364 21.3262 26.8364 22.7371 24.7273C24.308 22.371 22.7371 17.4546 22.7371 17.4546'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconRocket;
